import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-custom-switch',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './custom-switch.component.html',
  styleUrl: './custom-switch.component.css',
})
export class CustomSwitchComponent {
  @Input() checked: boolean = false;
  @Input() label: string = '';
  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle() {
    this.checkedChange.emit(this.checked);
  }
}
